<template>
  <div class="user">
    <div class="common-form">拼单记录</div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="active_id" label="拼单ID" width="100"></el-table-column>
            <el-table-column prop="active_id" label="商品图片" width="100"></el-table-column>
            <el-table-column prop="active_id" label="商品名称"></el-table-column>
            <el-table-column prop="active_id" label="	成团人数" width="100"></el-table-column>
            <el-table-column prop="active_date" label="已拼人员" width="150"></el-table-column>
            <el-table-column prop="active_time_count" label="发起人（团长)" width="150"></el-table-column>
            <el-table-column prop="active_time_count" label="	拼单结束时间" width="150"></el-table-column>
            <el-table-column prop="active_time_count" label="	拼单状态" width="100"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">拼团成员</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">拼团订单</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import SharingApi from '@/api/sharing.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        formInline: {},
        gradeList: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {}
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {};
        SeckillApi.activeList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {

          });
      },

      /*搜索查询*/
      onSubmit() {
        this.$message('这是一条消息提示');
      },
      /*复制*/
      copyClick() {
        this.$message('这是一条消息提示');
      },
      /*打开添加*/
      addClick() {
        // this.$router.push('/plus/seckill/active/Add');
      },

      /*场次管理*/
      editClick(row) {
        let self = this;
        let params = row.active_id;
        this.$router.push({
          path: '/plus/seckill/active/Edit',
          query: {
            active_id: params
          }
        })
      },
      /*刷新心也*/
      refresh() {
        this.reload();
        // 直接使用reload方法
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          StoreApi.deleteShop({
              shop_id: row.shop_id
            }, true)
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，门店删除成功',
                  type: 'success'
                });
                //刷新页面
                this.refresh();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {

            });

        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/sharing/sharing/Sharing.vue